import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export const Breadcrumbs = ({ items, dark = false }) => (
  <nav aria-label="Breadcrumb" data-testid="breadcrumbs">
    <ol className={`flex flex-wrap items-center gap-1.5 text-xs font-semibold uppercase tracking-[0.18em] ${dark ? "text-neutral-300" : "text-neutral-500"}`}>
      {items.map((it, i) => (
        <li key={it.path} className="flex items-center gap-1.5">
          {i < items.length - 1 ? (
            <Link to={it.path} className={dark ? "hover:text-white" : "hover:text-brand-ink"}>{it.name}</Link>
          ) : (
            <span aria-current="page" className={dark ? "text-brand-lime" : "text-brand-ink"}>{it.name}</span>
          )}
          {i < items.length - 1 && <ChevronRight className="h-3 w-3" aria-hidden="true" />}
        </li>
      ))}
    </ol>
  </nav>
);

export const PageHeader = ({ crumbs, eyebrow, title, highlight, lead, image, children }) => (
  <section className="on-dark grain relative overflow-hidden bg-brand-ink text-white">
    {image && <img src={image} alt="" aria-hidden="true" className="absolute inset-0 h-full w-full object-cover opacity-45" />}
    <div className="absolute inset-0 bg-black/40" aria-hidden="true" />
    <div className="relative mx-auto max-w-7xl px-4 py-16 sm:px-6 sm:py-24">
      <Breadcrumbs items={crumbs} dark />
      {eyebrow && <p className="eyebrow-lime mt-8 animate-fade-up">{eyebrow}</p>}
      <h1 className="mt-4 max-w-3xl animate-fade-up font-display text-4xl font-black leading-[0.95] tracking-tighter sm:text-5xl lg:text-6xl" style={{ animationDelay: "0.1s" }}>
        {title} {highlight && <span className="script-hl text-[1.08em]">{highlight}</span>}
      </h1>
      {lead && <p className="mt-6 max-w-2xl animate-fade-up text-base leading-relaxed text-neutral-300 sm:text-lg" style={{ animationDelay: "0.2s" }}>{lead}</p>}
      {children}
    </div>
  </section>
);
